import { Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { NavigationOptions, PaginationOptions } from 'swiper/types';
import { DatePipe, isPlatformBrowser } from "@angular/common";
import { environment } from "../../../../environments/environment";
import { Router } from "@angular/router";
import { ApiService } from 'src/app/services';

SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: 'app-home-banner-slider',
  templateUrl: './home-banner-slider.component.html',
  styleUrls: ['./home-banner-slider.component.scss']
})
export class HomeBannerSliderComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.detectScreenSize();
  }
  public bannerNavigation: NavigationOptions = {
    nextEl: '.banner-next',
    prevEl: '.banner-prev'
  };
  public bannerPagination: PaginationOptions = {
    el: '.pagination.banner-pagination'
  };
  isBigScreen
  apiUrl = environment.apiUrl
  selectedIndex = 0;
  dynamicBanners
  bannerItems: {
    img: {
      ka: string,
      kaSm: string
      en?: string,
      enSm?: string
    }
    name: string;
    shortUrl?: {};
    isBlog?: boolean;
  }[] = [];
  public selectedLanguage = localStorage.getItem('CurLang') || 'ka';
  isBannerLoaded = false

  constructor(@Inject(PLATFORM_ID) private platformId: any,
    private router: Router,
    private apiService: ApiService,
    private datePipe: DatePipe) {
    const today: string = datePipe.transform(new Date(), 'dd-MM-yyyy');
    // this.bannerItems = [

    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/nurse-ka.jpg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/nurse-ka-mob.jpg',
    //       en: 'assets/banner-images/new-banner-img/en/nurse-en.jpg',
    //       enSm: 'assets/banner-images/new-banner-img/en/nurse-en-mob.jpg'
    //     },
    //     name: 'nurse',
    //     shortUrl: {
    //       ka: 'http://t.ly/OnGBU',
    //       en: 'https://clinic.redmed.ge/search-stepper?step=search&selector=nurse&selectedLanguage=en'
    //     }
    //   },
    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/clinic.jpeg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/clinic-mob.jpeg',
    //       en: 'assets/banner-images/new-banner-img/en/clinic.jpeg',
    //       enSm: 'assets/banner-images/new-banner-img/en/clinic-mob.jpeg'
    //     },
    //     name: 'clinic',
    //     shortUrl: {
    //       ka: 'https://t.ly/Y2I_',
    //       en: 'https://t.ly/z3cp'
    //     }
    //   },
    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/pediatrician.jpg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/pediatrician-mob.jpg',
    //       en: 'assets/banner-images/new-banner-img/en/pediatrician-web.jpeg',
    //       enSm: 'assets/banner-images/new-banner-img/en/pediatrician-mob.jpeg'
    //     },
    //     name: 'pediatrician',
    //     shortUrl: {
    //       ka: 'http://t.ly/fWus',
    //       en: 'http://t.ly/XOGv'
    //     }
    //   },
    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/fam-doc.jpg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/fam-doc-mob.jpeg',
    //       en: 'assets/banner-images/new-banner-img/en/fam-doc-web.jpg',
    //       enSm: 'assets/banner-images/new-banner-img/en/fam-doc-mob.jpg'
    //     },
    //     name: 'family',
    //     shortUrl: {
    //       ka: 'http://t.ly/W6Lz',
    //     },
    //     isBlog: true
    //   },
    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/mental.jpeg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/mental-sm.jpeg',
    //       en: 'assets/banner-images/new-banner-img/en/mental.jpeg',
    //       enSm: 'assets/banner-images/new-banner-img/en/mental-sm.jpeg'
    //     },
    //     name: 'mental',
    //     shortUrl: 'https://bit.ly/3RoGMDB'
    //   },

    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/tbcins.jpeg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/tbcins-sm.jpeg',
    //       en: 'assets/banner-images/new-banner-img/en/tbcins.jpeg',
    //       enSm: 'assets/banner-images/new-banner-img/en/tbcins-sm.jpeg'
    //     },
    //     name: 'tbcins',
    //     shortUrl: 'https://bit.ly/3HKoidy'
    //   },
    //   {
    //     img: {
    //       ka: 'assets/banner-images/new-banner-img/ka/tatishvili.jpeg',
    //       kaSm: 'assets/banner-images/new-banner-img/ka/tatishvili-sm.jpeg',
    //       en: 'assets/banner-images/new-banner-img/en/tatishvili.jpeg',
    //       enSm: 'assets/banner-images/new-banner-img/en/tatishvili-sm.jpeg'
    //     },
    //     name: 'tatishvili',
    //     shortUrl: 'https://bit.ly/3RlyqMW'
    //   },
    // ];
  }

  ngOnInit(): void {
    this.apiService.getBanners().subscribe(res => {
      this.dynamicBanners = res
    })
    this.detectScreenSize();
  }

  detectScreenSize(): void {
    // You can adjust the breakpoint value as needed
    this.isBigScreen = window.innerWidth >= 768; // Example breakpoint: 768px
  }

  selectBannerImage(banner): string | undefined {
    const imagePlatformId = this.isBigScreen ? 1 : 2;
    const image = banner.images.find(img => img.imagePlatform.id === imagePlatformId);
    if (image) {
      return `${this.apiUrl}/banners/${banner.id}/images/${image.id}`;
    }
    return undefined;
  }
  

  goToClinicWeb(lab?: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (lab) {
        window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=&step=search&selector=lab&selectedLanguage=${this.selectedLanguage}`);
        return;
      }
      if (localStorage.getItem('UserAccessToken')) {
        window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&selectedLanguage=${this.selectedLanguage}`);
        return;
      }
    }
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge?selectedLanguage=${this.selectedLanguage}`);
  }

  goToBookingOrderTemplate(testTypeId: number, isEvent: boolean, isLab: boolean, selectedStudies: string, companyBranchId: number, isStudy: boolean): void {
    const token = this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'));
    // if (!token || token === 'null') {
    //   this.router.navigate(['ka/user/auth-user']);
    //   return;
    // }
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${token}&page=booking-order-template&booking-order-template-url=/order-booking/${companyBranchId}&bookingTestTypeId=${testTypeId}&bookingIsEvent=${isEvent}&bookingIsLab=${isLab}&bookingIsStudy=${isStudy}&bookingSelectedStudies=${selectedStudies}&selectedLanguage=${this.selectedLanguage}`);
  }

  goToBlog(url: string) {
    this.router.navigate([url]);
  }

  openNewTab(bannerItem): void {
    console.log(bannerItem);
  }

  fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }

}
